
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import IconInput from "./IconInput";

interface CategoryFormProps {
  initialData?: {
    id?: number;
    label: string;
    icon?: string;
  };
  onSubmit: (data: { label: string; icon: string }) => void;
  isSubcategory?: boolean;
  categories?: { id: number; label: string | null }[];
  parentCategoryId?: number;
  isEditing?: boolean;
}

const CategoryForm: React.FC<CategoryFormProps> = ({
  initialData = { label: "", icon: "Home" },
  onSubmit,
  isSubcategory = false,
  categories = [],
  parentCategoryId,
  isEditing = false
}) => {
  const [formData, setFormData] = useState({
    label: initialData.label || "",
    icon: initialData.icon || "Home",
    parentCategory: parentCategoryId || (categories[0]?.id || 0)
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      onSubmit({
        label: formData.label,
        icon: isSubcategory ? "" : formData.icon,
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Label htmlFor="categoryName">
          {isSubcategory ? "Subcategory Name" : "Category Name"}
        </Label>
        <Input
          id="categoryName"
          placeholder={isSubcategory ? "Enter subcategory name" : "Enter category name"}
          value={formData.label}
          onChange={(e) => setFormData({ ...formData, label: e.target.value })}
          required
        />
      </div>

      {!isSubcategory && (
        <div>
          <IconInput 
            value={formData.icon} 
            onChange={(value) => setFormData({ ...formData, icon: value })} 
          />
        </div>
      )}

      {isSubcategory && categories.length > 0 && (
        <div>
          <Label htmlFor="parentCategory">Parent Category</Label>
          <Select
            value={formData.parentCategory?.toString()}
            onValueChange={(value) => setFormData({ ...formData, parentCategory: Number(value) })}
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select parent category" />
            </SelectTrigger>
            <SelectContent>
              {categories.map((category) => (
                <SelectItem key={category.id} value={category.id.toString()}>
                  {category.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}

      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Saving..." : isEditing ? "Update" : "Add"}
      </Button>
    </form>
  );
};

export default CategoryForm;
